import { useEffect, useState } from 'react'
import { Table } from 'antd'
import { useGlobalModel } from "@/model/globalModel";
import { useNavModel } from "@/model/navModel";
import { BillOrderDetail } from '../settleTypes'
import { ColumnsType } from "antd/es/table";
import { detailModel } from './detailModel';
import YhTootip from '@/components/YhTootip'

export function DataTable() {

    const { dataSource, pgCfg, loadData, loading } = detailModel();
    const { getCiDictByDictCode } = useGlobalModel();
    const { addNav } = useNavModel(() => []);
    const [columns, setColumns] = useState<any[]>([])

    useEffect(() => {
        loadData();
    }, [])

    useEffect(() => {
        getColumns(dataSource?.length > 0 ? (dataSource[0]?.columns ?? []) : []);
    }, [dataSource])

    const getColumns = (customerColumns: any[]) => {
        setColumns([...startColumns, ...customerColumns, ...endColumns])
    }

    const startColumns: ColumnsType<BillOrderDetail> = [
        {
            title: '序号',
            width: 50,
            align: 'center',
            dataIndex: '',
            render: (t, r, i) => i + 1,
        },
        {
            title: '工单编号',
            width: 180,
            align: 'center',
            dataIndex: 'orderCode',
            render: (text, r) => (
                <div style={{ color: 'rgb(62, 103, 244)', cursor: 'pointer' }}
                    onClick={() => { addNav("18-1", { id: r.id, mode: "", orderInfo: r }) }}>
                    {text}
                </div>
            ),
        },
        {
            title: '工单状态',
            width: 100,
            align: 'center',
            dataIndex: 'orderStatus',
            render: (text) => getCiDictByDictCode(text)?.title,
        },
        {
            title: '客户名称',
            width: 200,
            align: 'center',
            dataIndex: 'customerName',
            render: (text) => <YhTootip text={text} />,
        },
        {
            title: '服务方式',
            width: 100,
            align: 'center',
            dataIndex: 'serviceMethod',
            render: (text) => getCiDictByDictCode(text)?.title,
        },
        {
            title: '故障类型',
            width: 100,
            align: 'center',
            dataIndex: 'faultClassification',
            render: (text) => <YhTootip text={getCiDictByDictCode(text)?.title} />,
        },
        {
            title: '车辆牌照',
            width: 100,
            align: 'center',
            dataIndex: 'customerVehicleCode',
            render: (text) => <YhTootip text={text} />,
        },
        {
            title: '工单类型',
            width: 100,
            align: 'center',
            dataIndex: 'orderType',
            render: (text) => <YhTootip text={getCiDictByDictCode(text)?.title} />,
        },
        {
            title: '工时费',
            width: 100,
            align: 'center',
            dataIndex: 'itemActualAmount',
            render: (text) => <YhTootip text={text} />,
        },
        {
            title: '配件费',
            width: 100,
            align: 'center',
            dataIndex: 'orderMaintainMaterialAmount',
            render: (text) => <YhTootip text={text} />,
        },
        {
            title: '工单金额',
            width: 100,
            align: 'center',
            dataIndex: 'orderActualAmount',
            render: (text) => <YhTootip text={text} />,
        },
        {
            title: '成本金额',
            width: 100,
            align: 'center',
            dataIndex: 'materialCostSumAmount',
            render: (text) => <YhTootip text={text} />,
        }
    ]

    const endColumns: ColumnsType<BillOrderDetail> = [
        {
            title: '工单来源',
            width: 100,
            align: 'center',
            dataIndex: 'orderSource',
            render: (text) => <YhTootip text={getCiDictByDictCode(text)?.title} />,
        },
        {
            title: '备注',
            width: 150,
            align: 'center',
            dataIndex: 'remark',
            render: (text) => <YhTootip text={text} />,
        },
        {
            title: '完成时间',
            width: 140,
            align: 'center',
            dataIndex: 'orderCompletedTime',
            render: (text) => <YhTootip text={text} />,
        },
        {
            title: '审核员',
            width: 100,
            align: 'center',
            dataIndex: 'reviewerName',
            render: (text) => <YhTootip text={text} />,
        }
    ]

    return (
        <>
            <Table
                rowKey={(record) => record.id}
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                pagination={{
                    ...pgCfg,
                    position: ['bottomRight'],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                    showSizeChanger: true,
                }}
                scroll={{ x: 'max-content', y: 'calc(100vh - 470px)' }}
            />
        </>
    )
}
